import type {AddComponentTypeOptions} from 'grapesjs';
import {createBaseInputComponent} from '@FormMakerReact/components/create-base-input-component';
import {FORM_INPUT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_LAST_NAME_INPUT_TYPE = 'postermywall-last-name-input';

export const POSTERMYWALL_LAST_NAME_INPUT: AddComponentTypeOptions = createBaseInputComponent({
  inputFieldType: POSTERMYWALL_LAST_NAME_INPUT_TYPE,
  inputName: 'last-name',
  dataMarkerAttribute: 'data-is-pmw-form-last-name-input',
  displayName: 'Last Name',
  placeholder: 'Enter your last name here',
  style: FORM_INPUT_STYLES,
  isComponentCheck: (el) => el.getAttribute('data-is-pmw-form-last-name-input') !== null,
});
